import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Balanceamento",
  path: "/merenda/merbalanceamento",
  name: "merbalanceamento",
  component: () => import("@/views/merenda/merbalanceamento/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.ITENSDEBALANCEAMENTONOVO_MENU_1000600299],
  },
  goesToMenu: true,
 },
];
